import React from 'react';
import { GroupCollapseIcon } from '../../../../../../global/group-collapse-icon/group-collapse-icon';
import './_control-list-group-header.scss';

interface IProps {
    colSpan: number;
    title: string;
    isCollapsed: boolean;
    isAllMeetingsCollapsed: boolean;
    onCollapseToggle?: () => void;
}

export const ControlListGroupHeader = (props: IProps) => {
    const { colSpan, title, isCollapsed = false, isAllMeetingsCollapsed = false, onCollapseToggle } = props;

    return (
        <tr className='control-list-group-header' onClick={() => onCollapseToggle?.()}>
            <th colSpan={colSpan} className='single-row-title-cell'>
                <GroupCollapseIcon isCollapsed={isCollapsed} isAllItemsCollapsed={isAllMeetingsCollapsed} />
                <div className='table-list-layout__inline-title'>
                    Status: <span>{title}</span>
                </div>
            </th>
        </tr>
    );
};
